import { render } from "./WxShare.vue?vue&type=template&id=0be89fdc&scoped=true"
import script from "./WxShare.vue?vue&type=script&lang=js"
export * from "./WxShare.vue?vue&type=script&lang=js"

import "./WxShare.vue?vue&type=style&index=0&id=0be89fdc&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be89fdc"]])

export default __exports__